import components from './components.json' with { type: 'json' };
import documentTitle from './document-title.json' with { type: 'json' };
import errors from './errors.json' with { type: 'json' };

export default {
  components,
  document_title: documentTitle,
  errors,
};
